import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';

import { contractsListSearchSchema } from '&/features/leasing/contracts/lib/contracts-list-search';
import { CONTRACTS_LIST_PERMISSION, LEASING_ORDER_PIPELINE_PATH } from '&/features/leasing/paths';

// Gated by the parent `/leasing` route (module switch + `leasing:access`); this one adds `contracts:list`
// (SWOOP-345). A user without it is sent to the first other Leasing page rather than `/leasing`, so there is
// no bounce with `/leasing`'s own redirect. On a hard refresh permissions may not be loaded yet, so
// `beforeLoad` lets that through (the list simply stays empty until the permission resolves).
export const Route = createFileRoute('/_authenticated/leasing/contracts')({
  beforeLoad: ({ context }): void => {
    if (context.permissions.isReady && !context.permissions.hasPermission(CONTRACTS_LIST_PERMISSION)) {
      throw redirect({ to: LEASING_ORDER_PIPELINE_PATH });
    }
  },
  component: lazyRouteComponent(() => import('&/features/leasing/pages/contracts-page')),
  staticData: { titleKey: 'leasingContracts' },
  // The list's search / status / page live in the URL (SWOOP-365), so a Back from a contract restores the
  // list. Every field is optional and coerced, so this never rejects.
  validateSearch: (search) => contractsListSearchSchema.parse(search),
});
